import React from "react";
// import products from "../../../data/news.json";
import Slider from "react-slick";
// import SingleNews from "../../../componet/Products/Product/SingleProduct/SingleNews";
// import Link from "next/link";
import { Col } from "react-bootstrap";
import { RecentArticalData } from "./RecentArticalData";

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  className: "center",
  centerPadding: "120px",
  centerMode: true,
  autoplay: true,
  autoplaySpeed: 1500,
  responsive: [
    {
      breakpoint: 1410,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 1,
        centerPadding: "220px",
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        centerPadding: "120px",
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        centerPadding: "50px",
      },
    },
  ],
};
const RecentArtical = () => {
  return (
    <>
      <div className="recentartical p-80-0">
        <div className="container">
          <div className="titlebtn pt-60 mb-40">
            <h2 class="text-center title font-cormorant">Recent Articles</h2>
          </div>
        </div>
        <Slider {...settings} className="row">
          {RecentArticalData.map((elm, index) => (
            <Col key={index}>
              <div className="position-relative">
                <div className="beffect">
                  <img
                    src={elm.image}
                    className="img-fluid mx-auto border-radius"
                    alt="SingleProduct"
                  />
                </div>
                <div className="newstitle position-absolute border-radius">
                  <div className="d-flex justify-space-between">
                    <p className="f-18">Date : {elm.blog_date} </p>
                    <p className="f-18">By : {elm.by} </p>
                  </div>
                  <h2 className="f-25 lh-35 m-20-0">
                    {elm.name}
                  </h2>
                  <p className="light_text">{elm.content}</p>
                </div>
              </div>
            </Col>
          ))}
        </Slider>
      </div>

    </>
  );
};



export default RecentArtical